/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M14 11L11 8M14 11L11 14M14 11H9.2C8.07989 11 7.51984 11 7.09202 11.218C6.71569 11.4097 6.40973 11.7157 6.21799 12.092C6 12.5198 6 13.0799 6 14.2V16.0001M15 8L18 11L15 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M14 11L11 8M14 11L11 14M14 11H9.2C8.07989 11 7.51984 11 7.09202 11.218C6.71569 11.4097 6.40973 11.7157 6.21799 12.092C6 12.5198 6 13.0799 6 14.2V16.0001M15 8L18 11L15 14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM11.5303 7.46967C11.2374 7.17678 10.7626 7.17678 10.4697 7.46967C10.1768 7.76256 10.1768 8.23744 10.4697 8.53033L12.1893 10.25H9.2H9.16957C8.63541 10.25 8.18956 10.25 7.82533 10.2797C7.44545 10.3108 7.08879 10.3779 6.75153 10.5497C6.23408 10.8134 5.81338 11.2341 5.54973 11.7515C5.37789 12.0888 5.31078 12.4454 5.27974 12.8253C5.24998 13.1896 5.24999 13.6354 5.25 14.1696L5.25 14.2V16.0001C5.25 16.4143 5.58579 16.7501 6 16.7501C6.41421 16.7501 6.75 16.4143 6.75 16.0001V14.2C6.75 13.6276 6.75058 13.2434 6.77476 12.9475C6.79822 12.6604 6.8401 12.5231 6.88624 12.4325C7.00608 12.1973 7.19731 12.0061 7.43251 11.8862C7.52307 11.8401 7.66035 11.7982 7.94748 11.7748C8.24336 11.7506 8.62757 11.75 9.2 11.75H12.1893L10.4697 13.4697C10.1768 13.7626 10.1768 14.2374 10.4697 14.5303C10.7626 14.8232 11.2374 14.8232 11.5303 14.5303L14.5303 11.5303C14.8232 11.2374 14.8232 10.7626 14.5303 10.4697L11.5303 7.46967ZM15.5303 7.46967C15.2374 7.17678 14.7626 7.17678 14.4697 7.46967C14.1768 7.76256 14.1768 8.23744 14.4697 8.53033L16.9393 11L14.4697 13.4697C14.1768 13.7626 14.1768 14.2374 14.4697 14.5303C14.7626 14.8232 15.2374 14.8232 15.5303 14.5303L18.5303 11.5303C18.8232 11.2374 18.8232 10.7626 18.5303 10.4697L15.5303 7.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 14.5L2 15V15C2 16.8613 2 17.7919 2.24472 18.5451C2.73931 20.0673 3.93273 21.2607 5.45491 21.7553C6.20808 22 7.13872 22 9 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2L9 2C7.13872 2 6.20808 2 5.45491 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9V9L2 9.5M14 11L11 8M14 11L11 14M14 11H9.2C8.07989 11 7.51984 11 7.09202 11.218C6.71569 11.4097 6.40973 11.7157 6.21799 12.092C6 12.5198 6 13.0799 6 14.2V15.6667V16.0001M15 8L18 11L15 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M14 11L11 8M14 11L11 14M14 11H9.2C8.07989 11 7.51984 11 7.09202 11.218C6.71569 11.4097 6.40973 11.7157 6.21799 12.092C6 12.5198 6 13.0799 6 14.2V16.0001M15 8L18 11L15 14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.4697 7.46967C10.7626 7.17678 11.2374 7.17678 11.5303 7.46967L14.5303 10.4697C14.8232 10.7626 14.8232 11.2374 14.5303 11.5303L11.5303 14.5303C11.2374 14.8232 10.7626 14.8232 10.4697 14.5303C10.1768 14.2374 10.1768 13.7626 10.4697 13.4697L12.1893 11.75H9.2C8.62757 11.75 8.24336 11.7506 7.94748 11.7748C7.66036 11.7982 7.52307 11.8401 7.43251 11.8862C7.19731 12.0061 7.00608 12.1973 6.88624 12.4325C6.8401 12.5231 6.79822 12.6604 6.77476 12.9475C6.75058 13.2434 6.75 13.6276 6.75 14.2V16.0001C6.75 16.4143 6.41421 16.7501 6 16.7501C5.58579 16.7501 5.25 16.4143 5.25 16.0001V14.2L5.25 14.1696C5.24999 13.6354 5.24998 13.1896 5.27974 12.8253C5.31078 12.4454 5.37789 12.0888 5.54973 11.7515C5.81338 11.2341 6.23408 10.8134 6.75153 10.5497C7.08879 10.3779 7.44545 10.3108 7.82533 10.2797C8.18957 10.25 8.63542 10.25 9.16957 10.25L9.2 10.25H12.1893L10.4697 8.53033C10.1768 8.23744 10.1768 7.76256 10.4697 7.46967ZM14.4697 7.46967C14.7626 7.17678 15.2374 7.17678 15.5303 7.46967L18.5303 10.4697C18.8232 10.7626 18.8232 11.2374 18.5303 11.5303L15.5303 14.5303C15.2374 14.8232 14.7626 14.8232 14.4697 14.5303C14.1768 14.2374 14.1768 13.7626 14.4697 13.4697L16.9393 11L14.4697 8.53033C14.1768 8.23744 14.1768 7.76256 14.4697 7.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
